import { get } from 'lodash-es';
import { getMixinRequests } from './manage';
export function triggerRequest(componentType, requestName, requestData) {
    const requests = getMixinRequests(componentType);
    const request = get(requests, requestName);
    return request === null || request === void 0 ? void 0 : request(requestData);
}
